import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { PlanningDayFeedback } from "../../../../interfaces/planning";
import { getAthletePlanningFeedback, updateAthletePlanningFeedback } from "../../../../services/planning";
import { UserContext } from "../../../../App";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface FeedbackProps {
    event: any;
    onClose: CallableFunction;
}

export function Feedback(props: FeedbackProps) {
    const { userProfile } = useContext(UserContext);

    const [loaded, setLoaded] = useState(false);
    const [feedbackData, setFeedbackData] = useState<PlanningDayFeedback>();
    const [fatigueLevel, setFatigueLevel] = useState(0);

    useEffect(() => {
        getAthletePlanningFeedback(userProfile.reference_id, props.event.datetime.substr(0, 10), props.event.day_moment, props.event.day_moment_session)
            .then(response => {
                setFeedbackData(response.data);
                setFatigueLevel(response.data.fatigue_level);
                setLoaded(true);
            });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            id: event.target.id.value,
            athlete_id: userProfile.reference_id,
            day: props.event.datetime.substr(0, 10),
            day_moment: props.event.day_moment,
            day_moment_session: props.event.day_moment_session,
            fatigue_level: fatigueLevel,
            observations: event.target.observations.value
        }
        updateAthletePlanningFeedback(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onClose();
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    const handleFeedbackLevelChange = (event: any) => {
        event.preventDefault();

        setFatigueLevel(event.currentTarget.dataset.value);
    }

    return (<Modal className="set-feedback-container" show={ true }
        onHide={ handleClose }> 
        <Modal.Header closeButton>
            <Modal.Title>
                { t("Feedback") }
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            { !loaded && <LoadingSpinner /> }
            { loaded &&
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group controlId="id">
                            <Form.Control type="hidden" name="day" required 
                                defaultValue={ feedbackData?.id } />
                        </Form.Group>
                        <div className="fatigue-level-field">
                            <div className="field-label">
                                { t("Level of fatigue")}
                            </div>
                            <div className="field-items">
                                { [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((r: number) => {
                                    return <a className={ 'field-item' + (r <= fatigueLevel ? ' active' : '') }
                                        data-value={ r } onClick={ handleFeedbackLevelChange }>
                                        { r }
                                    </a> 
                                })}                                
                            </div>
                        </div>
                        <Form.Group className="mb-3" controlId="observations">
                            <Form.Label>{ t("Observations") }</Form.Label>
                            <Form.Control name="observations" as="textarea"
                                defaultValue={ feedbackData?.observations } />
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            } 
        </Modal.Body>
    </Modal>);
}
